import { API_BASE_URL, authHeaders } from './api';

const VISITOR_ID_KEY = 'creatorcv_visitor_id';
const FIRST_SEEN_AT_KEY = 'creatorcv_first_seen_at';
const LEAD_SOURCE_KEY = 'creatorcv_lead_source';

function uuid() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// Persistent per-browser id. Reused both as the analytics session id sent on
// every event and as the anonymous identifier tied to lead_source
// attribution at signup, rather than tracking two separate anonymous ids.
export function getVisitorId() {
  let id = localStorage.getItem(VISITOR_ID_KEY);
  if (!id) {
    id = uuid();
    localStorage.setItem(VISITOR_ID_KEY, id);
  }
  return id;
}

function getFirstSeenAt() {
  let ts = localStorage.getItem(FIRST_SEEN_AT_KEY);
  if (!ts) {
    ts = new Date().toISOString();
    localStorage.setItem(FIRST_SEEN_AT_KEY, ts);
  }
  return ts;
}

export function getExampleCreatorUsername() {
  if (!window.location.pathname.startsWith('/example/')) return '';
  const segment = window.location.pathname.slice('/example/'.length).split('/')[0];
  let username = '';
  try {
    username = decodeURIComponent(segment).trim().toLowerCase();
  } catch {
    return '';
  }
  return username;
}

// First-touch attribution: the first source seen (as /landing/<lead_source>,
// /example/<creator_username>, or a ?lead_source= query param) wins and is
// kept for the lifetime of the browser; later visits never overwrite it.
function captureLeadSource() {
  const fromPath = window.location.pathname.startsWith('/landing/')
    ? decodeURIComponent(window.location.pathname.slice('/landing/'.length).split('/')[0])
    : '';
  const fromUrl = fromPath || getExampleCreatorUsername() || new URLSearchParams(window.location.search).get('lead_source');
  if (fromUrl && !localStorage.getItem(LEAD_SOURCE_KEY)) {
    localStorage.setItem(LEAD_SOURCE_KEY, fromUrl);
  }
  return localStorage.getItem(LEAD_SOURCE_KEY) || '';
}

// Runs once on module load (app bootstrap), before any client-side
// navigation can strip the query string from window.location.
captureLeadSource();

export function getSignupAttribution() {
  return {
    leadSource: captureLeadSource(),
    visitorId: getVisitorId(),
    firstSeenAt: getFirstSeenAt(),
  };
}

export function track(eventName, properties = {}) {
  const body = { eventName, sessionId: getVisitorId(), leadSource: captureLeadSource(), ...properties };
  fetch(`${API_BASE_URL}/v1/events`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => {});
}
